import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getMyWantToBuyList, getAdBannerList, delMyWantToBuy, delMySupply} from '@/api/miscellaneous';
import moment from 'moment';
import {useRouter} from 'vue-router';
import {calcDistance} from '@/libs/utils';
import userStoreModule from '@/store/modules/user';
import {Dialog, Toast} from 'vant';
import {format} from '@/libs/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyWantToBuyList',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const getListData = ref({
    page: 1,
    size: 10,
});
const loading = ref(false);
const finished = ref(false);
const list = ref<any[]>([]);
const adList = ref<any[]>([]);

const getList = () => {
    if (finished.value) return;
    loading.value = true;
    getMyWantToBuyList(getListData.value).then((res: any) => {
        loading.value = false;
        list.value = [...list.value, ...res.items];
        finished.value = res.totalCount == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
        getListData.value.page++;
    });
};
getList();
const getAdList = () => {
    getAdBannerList().then((res: any) => {
        adList.value = res;
    });
};
getAdList();

const distance = (point: {lat: number; lon: number}) => {
    if (userStoreModule.userDetail.location) {
        let {lat, lon} = userStoreModule.userDetail.location;
        const dis = calcDistance({lat: point.lat, lng: point.lon}, {lat, lng: lon});
        return dis > 1000 ? (dis / 1000).toFixed(2) + 'km' : dis.toFixed(2) + 'm';
    } else {
        return '';
    }
};

const del = (id: string, idx: number) => {
    Dialog.confirm({
        title: '提示',
        message: '确定删除该求购吗？',
        confirmButtonColor: 'red',
    }).then(() => {
        delMyWantToBuy({id}).then((res: any) => {
            Toast.success('删除成功');
            list.value.splice(idx, 1);
        });
    });
};

const __returned__ = { router, getListData, loading, finished, list, adList, getList, getAdList, distance, del, ref, getMyWantToBuyList, getAdBannerList, delMyWantToBuy, delMySupply, moment, useRouter, calcDistance, userStoreModule, Dialog, Toast, format }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})